import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { BankPortalService, NotificationUserService } from '../../web-api-client';
@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private hubConnection!: signalR.HubConnection;
  private notificationSubject = new Subject<Array<string>>();
  public notification$ = this.notificationSubject.asObservable();
  constructor(private _bankportalService: BankPortalService, private _notificationUserService:NotificationUserService) {
  }

  public startConnection = () => {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.api_url}/notificationHub`, {
        skipNegotiation: true,
        accessTokenFactory: () => localStorage.getItem('idToken')!,
        transport: signalR.HttpTransportType.WebSockets

      })
      .configureLogging(signalR.LogLevel.Error)
      .withAutomaticReconnect()
      .build();

    this.hubConnection.on('NotifyBank', (data) => {
      this._bankportalService.bankPortal_GetAllNotifications().subscribe(res => {
        var userNotifications = res;
        this.notificationSubject.next(userNotifications as any);
      },
        err => {
          console.log(err);
        });
    });
    this.hubConnection.on('Hello', (data) => {
      alert("notification aayo");
    });

    this.hubConnection
      .start()
      .then(() => console.log('Connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }

  public disconnect(): void {
    if (typeof this.hubConnection !== 'undefined') {
      this.hubConnection.stop()
        .then(() => console.log('Connection stopped'))
        .catch(err => console.log('Error while stopping connection: ' + err));
    }

  }
}
